// extracted by mini-css-extract-plugin
module.exports = {"anchorTag":"styles_anchorTag__2AiiX","settingsAnchorTag":"styles_settingsAnchorTag__2pfjQ"};